import React, { useState, useEffect } from 'react';
import axios from 'axios';
// import jackolantern from './Assets/jackolantern.png';
// import autumnleaves from './Assets/autumnleaves.png';
// import windyleaves from './Assets/windyleaves.png';
// import christmas from './Assets/christmas.png';

function WeeklySchedule() {
  // Team color gradients for selected teams
  const teamGradients = {
    'Arizona Cardinals': 'linear-gradient(90deg, #97233F 60%, #000000 100%)',
    'Atlanta Falcons': 'linear-gradient(90deg, #A71930 60%, #000000 100%)',
    'Baltimore Ravens': 'linear-gradient(90deg, #241773 60%, #9E7C0C 100%)',
    'Buffalo Bills': 'linear-gradient(90deg, #00338D 60%, #C60C30 100%)',
    'Carolina Panthers': 'linear-gradient(90deg, #0085CA 60%, #101820 100%)',
    'Chicago Bears': 'linear-gradient(90deg, #0B162A 60%, #C83803 100%)',
    'Cincinnati Bengals': 'linear-gradient(90deg, #FB4F14 60%, #000000 100%)',
    'Cleveland Browns': 'linear-gradient(90deg, #311D00 60%, #FF3C00 100%)',
    'Dallas Cowboys': 'linear-gradient(90deg, #003594 60%, #A5ACAF 100%)',
    'Denver Broncos': 'linear-gradient(90deg, #FB4F14 60%, #002244 100%)',
    'Detroit Lions': 'linear-gradient(90deg, #0076B6 60%, #B0B7BC 100%)',
    'Green Bay Packers': 'linear-gradient(90deg, #203731 60%, #FFB81C 100%)',
    'Houston Texans': 'linear-gradient(90deg, #03202F 60%, #A71930 100%)',
    'Indianapolis Colts': 'linear-gradient(90deg, #002C5F 60%, #A2AAAD 100%)',
    'Jacksonville Jaguars': 'linear-gradient(90deg, #006778 60%, #9F792C 100%)',
    'Kansas City Chiefs': 'linear-gradient(90deg, #E31837 60%, #FFB81C 100%)',
    'Las Vegas Raiders': 'linear-gradient(90deg, #000000 60%, #A5ACAF 100%)',
    'Los Angeles Chargers': 'linear-gradient(90deg, #0080C6 60%, #FFC20E 100%)',
    'Los Angeles Rams': 'linear-gradient(90deg, #003594 60%, #FFD100 100%)',
    'Miami Dolphins': 'linear-gradient(90deg, #008E97 60%, #FC4C02 100%)',
    'Minnesota Vikings': 'linear-gradient(90deg, #4F2683 60%, #FFC62F 100%)',
    'New England Patriots': 'linear-gradient(90deg, #002244 60%, #C60C30 100%)',
    'New Orleans Saints': 'linear-gradient(90deg, #D3BC8D 60%, #101820 100%)',
    'New York Giants': 'linear-gradient(90deg, #0B2265 60%, #A71930 100%)',
    'New York Jets': 'linear-gradient(90deg, #125740 60%, #000000 100%)',
    'Philadelphia Eagles': 'linear-gradient(90deg, #004C54 60%, #A5ACAF 100%)',
    'Pittsburgh Steelers': 'linear-gradient(90deg, #FFB81C 60%, #101820 100%)',
    'San Francisco 49ers': 'linear-gradient(90deg, #AA0000 60%, #B3995D 100%)',
    'Seattle Seahawks': 'linear-gradient(90deg, #002244 60%, #69BE28 100%)',
    'Tampa Bay Buccaneers': 'linear-gradient(90deg, #D50A0A 60%, #34302B 100%)',
    'Tennessee Titans': 'linear-gradient(90deg, #4B92DB 60%, #0C2340 100%)',
    'Washington Commanders': 'linear-gradient(90deg, #5A1414 60%, #FFB612 100%)',
  };
  const [schedule, setSchedule] = useState([]);
  const [teamRecords, setTeamRecords] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userPicks, setUserPicks] = useState({});
  const [useToken, setUseToken] = useState(false);
  const [submissionStatus, setSubmissionStatus] = useState(null);
  const [hasSubmittedPicks, setHasSubmittedPicks] = useState(false);
  const [userTokens, setUserTokens] = useState(0);
  const [combinedScore, setCombinedScore] = useState('');
  const [currentWeek, setCurrentWeek] = useState(1);
  const [seasonYear, setSeasonYear] = useState(null);
  const [submissionsLocked, setSubmissionsLocked] = useState(false);
  const [leagueNumber, setLeagueNumber] = useState(null);

  useEffect(() => {
  const fetchScheduleAndUserData = async () => {
      try {
        let nflSchedule = [];
        let lockStatus = false;
        let weekNum = 1;
        let yearNum = null;

        // 1. Get the schedule and current week
        try {
          const nflResponse = await axios.get(`${process.env.REACT_APP_API_URL}/api/nfl-schedule`); // updated
          nflSchedule = nflResponse.data.games || [];
          weekNum = nflResponse.data.week || 1;
          yearNum = nflResponse.data.year || null;
          setCurrentWeek(weekNum);
          setSeasonYear(yearNum);
          lockStatus = nflResponse.data.submissionsLocked || false;
        } catch (nflError) {
          nflSchedule = [];
        }

        setSchedule(nflSchedule);
        setSubmissionsLocked(lockStatus);

        // 2. Fetch team records from ESPN API
        try {
          const espnResponse = await axios.get('https://site.api.espn.com/apis/site/v2/sports/football/nfl/scoreboard');
          const events = espnResponse.data.events || [];
          const recordsMap = {};
          events.forEach(event => {
            if (event.competitions && event.competitions[0] && event.competitions[0].competitors) {
              event.competitions[0].competitors.forEach(comp => {
                const teamName = comp.team && comp.team.displayName;
                const record = comp.records && comp.records[0] && comp.records[0].summary;
                if (teamName && record) {
                  recordsMap[teamName] = record;
                }
              });
            }
          });
          setTeamRecords(recordsMap);
        } catch (espnError) {
          setTeamRecords({});
        }
        // Comment 
        // 3. Initialize picks for the schedule
        const initialPicks = {};
        nflSchedule.forEach(game => {
          initialPicks[game.id] = null;
        });
        setUserPicks(prevPicks => {
          const updatedPicks = { ...prevPicks };
          nflSchedule.forEach(game => {
            if (updatedPicks[game.id] === undefined) {
              updatedPicks[game.id] = null;
            }
          });
          return updatedPicks;
        });

        // 4. Get user info and picks for the CURRENT week
        const token = localStorage.getItem('token');
        if (token) {
          const profileResponse = await axios.get(`${process.env.REACT_APP_API_URL}/api/profile`, { // updated
            headers: { Authorization: `Bearer ${token}` }
          });
          setUserTokens(profileResponse.data.tokens);
          setLeagueNumber(profileResponse.data.league_number);

          // --- KEY FIX: Always check for picks for the CURRENT week ---
          const hasSubmittedResponse = await axios.get(
            `${process.env.REACT_APP_API_URL}/api/user-picks?week=${weekNum}${yearNum ? `&year=${yearNum}` : ''}`, // updated
            { headers: { Authorization: `Bearer ${token}` } }
          );
          setHasSubmittedPicks(hasSubmittedResponse.data.hasSubmitted);

          // Fetch actual picks for the current week
          try {
            const picksResponse = await axios.get(`${process.env.REACT_APP_API_URL}/api/my-picks-results`, { // updated
              headers: { Authorization: `Bearer ${token}` }
            });
            const picksData = picksResponse.data;
            const picksMap = {};
            picksData.forEach(pick => {
              picksMap[pick.game_id] = pick.picked_team;
            });
            setUserPicks(prev => ({ ...prev, ...picksMap }));
          } catch (err) {
            // Error fetching user picks for highlight
          }
        }

        setLoading(false);
      } catch (err) {
        setError('Error fetching data');
        setLoading(false);
      }
    };

    fetchScheduleAndUserData();

    // Check submission status every minute
    const interval = setInterval(fetchScheduleAndUserData, 60000);
    return () => clearInterval(interval);
  }, [currentWeek]);

  // Helper function to format game time
  const formatGameTime = (dateString) => {
    if (!dateString) return 'TBD';
    return new Date(dateString).toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit'
    });
  };

  // Helper function to show game status
  const getGameStatus = (game) => {
    switch(game.status) {
      case 'STATUS_FINAL': return 'Final';
      case 'STATUS_IN_PROGRESS': return 'Live';
      case 'STATUS_HALFTIME': return 'Halftime';
      default: return 'Scheduled';
    }
  };

  const handlePickChange = (gameId, team) => {
    if (!hasSubmittedPicks && !submissionsLocked) {
      setUserPicks(prevPicks => ({
        ...prevPicks,
        [gameId]: team,
      }));
    }
  };

  const handleSubmitPicks = async () => {
     if (submissionsLocked) {
       setSubmissionStatus({ success: false, message: 'Submissions Locked, please check back Wednesday.' });
       return;
     }

     const allGamesPicked = schedule.every(game => userPicks[game.id] !== null);
     if (!allGamesPicked) {
       setSubmissionStatus({ success: false, message: 'Please make a pick for every game.' });
       return;
     }
     if (!combinedScore || isNaN(combinedScore) || Number(combinedScore) <= 0) {
       setSubmissionStatus({ success: false, message: 'Please enter a valid combined score prediction for the final game.' });
       return;
     }

     const formattedPicks = schedule.map(game => ({
       gameId: game.id,
       pickedTeam: userPicks[game.id],
     }));

     try {
       const token = localStorage.getItem('token');

       if (!token) {
         setSubmissionStatus({ success: false, message: 'Please log in to submit picks.' });
         return;
       }

       setSubmissionStatus({ success: null, message: 'Submitting picks...' });

       const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/submit-picks`, { // updated
         picks: formattedPicks,
         useToken: useToken,
         combinedScore: Number(combinedScore),
         week: currentWeek,
         year: seasonYear
       }, {
         headers: {
           Authorization: `Bearer ${token}`,
         },
       });

       setSubmissionStatus({ success: true, message: response.data.message });
       setHasSubmittedPicks(true);

     } catch (error) {
       setSubmissionStatus({ success: false, message: error.response?.data?.error || 'Error submitting picks' });
     }
  };

  const handleChangePicks = async () => {
    try {
      const token = localStorage.getItem('token');
      const yearParam = seasonYear ? `&year=${seasonYear}` : '';
      await axios.delete(`${process.env.REACT_APP_API_URL}/api/user-picks?week=${currentWeek}${yearParam}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      // Refetch user picks status after deletion
      const hasSubmittedResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/user-picks?week=${currentWeek}${yearParam}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setHasSubmittedPicks(hasSubmittedResponse.data.hasSubmitted);
      setSubmissionStatus({ success: true, message: 'Picks removed. You may resubmit.' });
      setUserPicks({});
      setCombinedScore('');
    } catch (err) {
      setSubmissionStatus({ success: false, message: 'Error removing picks. Please try again.' });
    }
  };

  // Determine if picks can be changed or submitted
  const canPick = !hasSubmittedPicks && !submissionsLocked;

  if (loading) {
    return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p className="loading-text">Loading schedule...</p>
    </div>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="weekly-schedule">
      {leagueNumber === 1 && (
      <div className="token-balance"><span>Token Balance:</span> {userTokens}</div>
      )}
      <div>
        <h2>NFL <span>2026-27</span> Schedule</h2>
        <p><span>Current Week:</span> Week {currentWeek}</p>
        {/* <img
          src={christmas}
          alt="christmas decoration"
          className="schedule-image"
        /> */}
      </div>
        {submissionsLocked && (
          <div className="alert alert-warning" style={{
            backgroundColor: '#fff3cd',
            border: '1px solid #ffeaa7',
            padding: '10px',
            borderRadius: '5px',
            marginBottom: '20px',
            color: '#856404'
          }}>
            Submissions Locked, please check back Wednesday.
          </div>
        )}
      {schedule.length > 0 ? (
        <>
          <ul className="schedule-list">
            {schedule.map((game) => (
              <li key={game.id} className="schedule-item">
                <div className="matchup-info">
                  <div>
                    <span
                      className={`team-name${userPicks[game.id]==='Visitor' ? ' selected-team animate-bar' : ''}`}
                      style={
                        userPicks[game.id] === 'Visitor' && teamGradients[game.visitor_team]
                          ? { background: teamGradients[game.visitor_team], color: '#fff', borderRadius: '6px', padding: '2px 8px' }
                          : {}
                      }
                    >
                      {game.visitor_team}
                    </span>
                    <span className="team-record"> ({teamRecords[game.visitor_team] || 'N/A'})</span> <span className='subtext'>Visitor</span>
                    {(game.status === 'STATUS_IN_PROGRESS' || game.status === 'STATUS_HALFTIME' || game.status === 'STATUS_FINAL') && (
                      game.visitor_score && (
                        <span
                          className="live-score"
                          style={{ color: Number(game.visitor_score) > Number(game.home_score) ? 'goldenrod' : undefined }}>
                          {game.visitor_score}
                        </span>
                      )
                    )}
                  </div>
                  <div>
                    <span
                      className={`team-name${userPicks[game.id]==='Home' ? ' selected-team animate-bar' : ''}`}
                      style={
                        userPicks[game.id] === 'Home' && teamGradients[game.home_team]
                          ? { background: teamGradients[game.home_team], color: '#fff', borderRadius: '6px', padding: '2px 8px' }
                          : {}
                      }
                    >
                      {game.home_team}
                    </span>
                    <span className="team-record"> ({teamRecords[game.home_team] || 'N/A'})</span> <span className='subtext'>Home</span>
                    {(game.status === 'STATUS_IN_PROGRESS' || game.status === 'STATUS_HALFTIME' || game.status === 'STATUS_FINAL') && (
                      game.home_score && (
                        <span
                          className="live-score"
                          style={{ color: Number(game.home_score) > Number(game.visitor_score) ? 'goldenrod' : undefined }}>
                          {game.home_score}
                        </span>
                      )
                    )}
                  </div>
                </div>
                <div className={`selection-options ${(!canPick) ? 'locked' : ''}`}>
                  <label className={userPicks[game.id] === 'Visitor' ? 'selected-option' : ''}>
                    <input
                      type="radio"
                      name={`game-${game.id}`}
                      value="Visitor"
                      checked={userPicks[game.id] === 'Visitor'}
                      onChange={() => handlePickChange(game.id, 'Visitor')}
                      disabled={!canPick}
                    />{' '}
                    V
                  </label>
                  <label className={userPicks[game.id] === 'Home' ? 'selected-option' : ''}>
                    <input
                      type="radio"
                      name={`game-${game.id}`}
                      value="Home"
                      checked={userPicks[game.id] === 'Home'}
                      onChange={() => handlePickChange(game.id, 'Home')}
                      disabled={!canPick}
                    />{' '}
                    H
                  </label>
                </div>
                <div className="gametime">
                  <span>{formatGameTime(game.game_time)}</span>
                  {game.status && game.status !== 'scheduled' && (
                    <span className="game-status"> • {getGameStatus(game)}</span>
                  )}
                </div>
              </li>
            ))}
          </ul>

          {/* Combined score input and submit only if picks not submitted and not locked */}
          {canPick && (
            <>
              <div className="schedule-item score-prediction">
                <div className="combined-score-section">
                  <label htmlFor="combined-score-input">
                    Combined final score for Monday Night Game:
                    <input
                      id="combined-score-input"
                      type="number"
                      min="1"
                      value={combinedScore}
                      onChange={e => setCombinedScore(e.target.value)}
                      required
                      disabled={!canPick}
                    />
                  </label>
                </div>
              </div>
              <div className='submit-section'>
                {leagueNumber === 1 && (
                <label>
                  <input
                    type="checkbox"
                    checked={useToken}
                    onChange={(e) => setUseToken(e.target.checked)}
                    disabled={!canPick}
                  />{' '}
                  Use Token (Current Balance: {userTokens})
                </label>
                )}
                <button className="submit-button" onClick={handleSubmitPicks} disabled={!canPick}>
                  Submit Picks
                </button>
              </div>
            </>
          )}
        </>
      ) : (
        <p>No schedule available for this week. Check back Wednesday.</p>
      )}

      {/* Display submission status message (always visible) */}
      {submissionStatus && (
        <p style={{ color: submissionStatus.success ? 'green' : 'red' }}>
          {submissionStatus.message}
        </p>
      )}

      {hasSubmittedPicks && !submissionsLocked && (
        <div style={{ textAlign: 'center', margin: '20px 0' }}>
          <button className="submit-button" onClick={handleChangePicks}>
            Change Picks
          </button>
        </div>
      )}
    </div>
  );
}

export default WeeklySchedule;

